module.exports = __webpack_public_path__ + "static/media/file-pdf-24.1edb2914.svg";